import { requestApi, HttpMethods } from '~/services/api-new';

import { DocumentResponse, DocumentUploadResponse } from './types';
import { DOC_URI } from './constants';

export const fetchDocuments = async () => {
	return requestApi<DocumentResponse>({
		endpoint: DOC_URI
	});
};

export const uploadDocument = async (file: File, credentials: unknown) => {
	const form = new FormData();
	form.append('file', file);

	if (credentials) {
		form.append('credentials', JSON.stringify(credentials));
	}

	return requestApi<DocumentUploadResponse>({
		endpoint: DOC_URI,
		method: HttpMethods.POST,
		payload: form
	});
};
